document.addEventListener('DOMContentLoaded', () => {
  let element = document.querySelector(
    '.christmas-campaign-company-list-block'
  );

  if (element) {
    function slideCountInit() {
      jQuery(element).append(
        '<div class="tns-slide-count"><span class="current-slide"></span> / <span class="slide-count"></span></div>'
      );
      jQuery(element)
        .find('.christmas-campaign-company-list-block__inner')
        .show();
    }

    import('tiny-slider/src/tiny-slider').then((module) => {
      let slider = module.tns({
        loop: false,
        mouseDrag: true,
        //edgePadding: 40,
        gutter: 20,
        navPosition: 'bottom',
        controls: true,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        preventScrollOnTouch: 'auto',
        onInit: slideCountInit,
        nextButton: document.querySelector('.js-christmas-campaign-nav-next'),
        prevButton: document.querySelector(
          '.js-christmas-campaign-nav-previous'
        ),
        //center: true,
        responsive: {
          600: {
            items: 1,
          },
          800: {
            items: 2,
          },
          1000: {
            items: 3,
          },
          1200: {
            items: 4,
          },
        },
      });

      function updateCurIndexCount() {
        jQuery('.tns-slide-count .current-slide').text(
          slider.getInfo().index + 1
        );
      }

      jQuery('.tns-slide-count .current-slide').text(
        slider.getInfo().index + 1
      );
      jQuery('.tns-slide-count .slide-count').text(slider.getInfo().slideCount);
      slider.events.on('indexChanged', updateCurIndexCount);
    });
  }
});
